import { debugLog } from "../Utils/LogUtils";
import jsPDF from 'jspdf';
import {generateEnrolmentDocumentPDFToBlob} from "./PDFGeneration";
import GroupQuote from "../Quotes/GroupQuote";
import {useEffect, useState} from "react";

const PDFViewer = ({data}) => {
    const [quoteImage, setQuoteImage] = useState('');
    const [blobURL, setBlobURL] = useState('');

    //Once the image from the quote is provided, we can generate the full PDF
    useEffect(() => {
        if (!quoteImage) { return; }

        const pdfData = generateEnrolmentDocumentPDFToBlob(data, quoteImage);
        setBlobURL(URL.createObjectURL(pdfData));

    }, [quoteImage]);


    //This is a sample method that posts the PDF to a backend - intended to demonstrate sending it off to Docusign
    const sendPDFForSignature = () => {
        const pdfData = generateEnrolmentDocumentPDFToBlob(data);

        //We use a FileReader to convert the Blob to Base64
        const reader = new FileReader();
        reader.readAsDataURL(pdfData);
        reader.onloadend = function () {
            //Get just the base64data from the object URL
            const base64data = reader.result.split(',')[1];

            fetch(process.env.REACT_APP_BACKEND_URL+"/signPDF", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({pdfData: base64data})
            }).then(response => {
                if (response.ok) {
                    debugLog(response); // Handle success response
                } else {
                    throw new Error('Network response was not ok.');
                }
                return response.json();
            }).then(data => {
                debugLog(data); // Handle success response
            }).catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });
        }
    }

    return (
        <div>
            <button onClick={sendPDFForSignature}>Sign PDF</button>
            <iframe title={'Enrolment Review'} src={blobURL} style={{width: "100%", height: "95vh"}}/>
            {
                //TODO: This should be the correct quote(s) based on the plan(s) selected
            }
            {!quoteImage &&
                <GroupQuote state={data} setQuoteImage={setQuoteImage} />
            }
        </div>
    )
}

export default PDFViewer;